import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CrearUnidad = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/unidades-medidas`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearUnidadMutation: mutation.mutate,
    };
}